import React from 'react'
import { Users, Shield } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

interface PartnershipsHeaderProps {
  className?: string
}

const PartnershipsHeader: React.FC<PartnershipsHeaderProps> = ({ className }) => {
  return (
    <div className={className}>
      <Card variant="elevated">
        <CardContent className="p-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-gray-100 dark:bg-gray-800 flex items-center justify-center rounded-full">
              <Users size={24} className="text-gray-700 dark:text-gray-300" />
            </div>
            <div className="flex-1">
              <p className="text-[var(--muted-foreground)] leading-relaxed">
                If you're managing a community of investors and looking to tap into this business, become our partner at 0 cost to you, in a few hours.
              </p>
            </div>
            <Badge variant="outline">
              <Shield size={16} className="mr-2" />
              Official Partner
            </Badge>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default PartnershipsHeader 